import { createSlice } from '@reduxjs/toolkit'
import { Status } from '../../@types/status'
import { Resource } from '../../@types/resource'
import { fetchValuation } from './thunks'
import { Valuation } from '../../@types/valuation'

export const initialState: Resource<Valuation> = { status: Status.LOADING }

const valuationSlice = createSlice({
  name: 'valuation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchValuation.fulfilled, (state, action) => {
      const { min, max } = action.payload.meta.range

      const valuation: Resource<Valuation> = {
        status: Status.SUCCESS,
        data: {
          range: {
            min: min,
            max: max,
          },
          prevRange: state.data?.range,
          value: action.payload.value,
        },
      }

      return { ...state, ...valuation }
    })
    builder.addCase(fetchValuation.rejected, (state, action) => {
      const errorMsg = action.payload ? action.payload : action.error
      console.error(errorMsg)

      return { ...state, status: Status.ERROR }
    })
    builder.addCase(fetchValuation.pending, (state) => {
      return { ...state, status: Status.LOADING }
    })
  },
})

export default valuationSlice.reducer
